/* eslint-disable indent,no-new,no-undef */
/* eslint-env mocha
 * Onboarding options for all packages form rendering
 */
export default {
  data: function () {
    return {
      notifications_settings: [
        {
          star_ratings_settings: {
            title: 'Send me notifications about the following reviews:',
            form_element: 'checkbox',
            elements: ['1 star reviews', '2 star reviews', '3 star reviews', '4 star reviews', '5 star reviews'],
            type: 'collection'
          },
          email_settings: {
            title: 'Email notifications',
            sub_title: 'Send me notifications to <strong>' + localStorage.getItem('email') + '</strong> for the following:',
            form_element: 'radio',
            elements: ['All review activity (new reviews, new messages, reported reviews, deleted reviews)',
              'New review notifications only',
              'I don\'t want to get notifications'
            ],
            elements_values: ['ALL_REVIEW_ACTIVITY', 'NEW_REVIEW_ONLY', 'NONE'],
            type: 'collection'
          },
          sms_settings: {
            title: 'SMS notifications',
            element: 'Send me sms notifications to <strong>' + localStorage.getItem('mobile_number') + '</strong>',
            type: 'checkbox'
          },
          additional_notifications: {
            title: 'Additional notifications',
            sub_title: 'Add up to <strong>3</strong> additional email addresses to receive notifications about all review activity.',
            type: 'modal_link'
          }
        }
      ],
      additional_notifications_form_elements: [
        {
          fields: []
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/notifications-settings.js